<template>
  <div class="brand-page" ref="gallery">
    <div class="topBar">
      <div class="subTitle">
        <i
          class="far fa-window-minimize"
          style="transform:rotate(90deg);margin-right: -10px;color:rgba(52,152,219,1);"
        ></i>
        积分规则
        <div class="rutun">
          <div>
            <i class="fas fa-sync-alt"></i>
          </div>
          <div style="margin-left:4px" @click="geting()">刷新</div>
        </div>
      </div>
    </div>
    <div v-if="role" style="width: 1056px;margin: 0 auto;border:1px solid #ddd;margin-top:30px;">
      <div class="form-title">
        <div style="margin-left:30px;line-height:46px">积分规则</div>
      </div>

      <div class="table">
        <div class="tab_task">
          <h4>新手任务</h4>
          <p>新手任务每个用户只奖励一次,相关值必须大于0的整数</p>
        </div>
        <table class="tab_box" cellspacing="0">
          <tr class="tab_tr" v-for="item in tabDate" :key="item.id">
            <th class="tab_th" v-if="item.type==1">{{item.name}}</th>
            <td class="tab_td" style="position: relative;" v-if="item.type==1">
              奖励积分:
              <el-input style="width:30%;margin-left:10px;" v-model="item.number"></el-input>
              <div class="num">分</div>
            </td>
          </tr>
        </table>
        <div class="tab_task">
          <h4>日常任务</h4>
          <p>日常任务可以奖励多次,相关值必须大于0的整数</p>
        </div>
        <table class="tab_box" cellspacing="0">
          <tr class="tab_tr" v-for="item in tabDate" :key="item.id">
            <th class="tab_th" v-if="item.type == 2">{{item.name}}</th>
            <td class="tab_td" v-if="item.type == 2" style="position: relative;">
              奖励积分:
              <el-input style="width:30%;" v-model="item.number"></el-input>
              <div class="num">分</div>
            </td>
          </tr>
        </table>
        <div style="width:300px;height:80px;margin:0 auto;margin-top:30px;">
          <el-row>
            <el-button
              style="margin-left:50px;width:80px;height:36px"
              type="primary"
              @click="submit()"
            >提交</el-button>
          </el-row>
        </div>
      </div>
    </div>
    <noAccess v-else></noAccess>
  </div>
</template>
<script>
export default {
  data() {
    return {
      serve: this.$store.state.serve,
      role: true,
      username: "",
      token: "",
      tabDate: []
    };
  },
  created() {
    this.$store.state.leftTitle = "积分规则";
    this.geting();
    this.$store.state.topActiveId = 4;
  },

  methods: {
    open6() {
      this.$message({
        showClose: true,
        message: "提交成功",
        type: "success"
      });
    },
    open8() {
      this.$message({
        showClose: true,
        message: "提交失败",
        type: "error"
      });
    },
    geting() {
      const that = this;
      this.username = this.$cookies.get("username");
      this.token = this.$cookies.get("token");
      this.axios
        .get(this.serve + "/admin/integral_regulation", {
          params: {
            username: this.username,
            token: this.token
          }
        })
        .then(res => {
          if (res.data.status == "success") {
            var json = res.data.data;
            for (var key in json) {
              that.tabDate.push(json[key]);
            }
          } else {
            if(res.data.msg == "无权访问")
            {
              that.role = false
            }
          }
        });
    },
    submit(id) {
      this.axios
        .get(this.serve + "/admin/submit_integral_regulation", {
          params: {
            username: this.username,
            token: this.token,
            tabDate: this.tabDate
          }
        })
        .then(res => {
          if (res.data.status == "success") {
            this.open6();
          }else if(res.data.code == '403'){
            this.$message.error(res.data.msg); 
          }  else if (res.data.status == "error") {
            this.open8();
          }
        });
    }
  }
};
</script>

<style lang="scss">
.topBar {
  margin-bottom: 40px;
  .el-step__icon {
    height: 54px;
    width: 54px;
  }
  .subTitle {
    width: 1050px;
    margin: 0 auto;
    font-size: 14px;
    position: relative;
  }
  .rutun {
    width: 78px;
    height: 28px;
    background: #fff;
    border: 1px solid rgba(221, 221, 221, 1);
    text-align: center;
    margin-top: 9px;
    display: flex;
    align-items: center;
    justify-content: center;
    position: absolute;
    right: 0;
    top: 0;
    cursor: pointer;
  }
  .rutun:hover {
    color: #0099ff;
  }
}
.table {
  background: #fff;
  .tab_task {
    display: flex;
    align-items: center;
    > h4 {
      margin-left: 30px;
    }
    > p {
      margin-left: 20px;
      font-size: 14px;
      font-family: "MicrosoftYaHei";
      font-weight: 400;
      color: rgba(153, 153, 153, 1);
    }
  }
  .tab_box {
    width: 95%;
    margin: 0 auto;
    margin-bottom: 16px;

    .tab_tr {
      width: 100%;
      height: 100%;
      border: 1px solid rgba(221, 221, 221, 1);
      .tab_th {
        padding: 0;
        margin: 0;
        width: 300px;
        height: 60px;
        background: rgba(245, 250, 249, 1);
        border: 1px solid rgba(221, 221, 221, 1);
        font-size: 14px;
        text-align: center;
        font-weight: 400;
        color: rgba(51, 51, 51, 1);
      }
      .tab_td {
        padding: 0;
        margin: 0;
        border: 1px solid rgba(221, 221, 221, 1);
        padding-left: 80px;
        font-size: 14px;
        font-weight: 400;
        color: rgba(51, 51, 51, 1);
      }
    }
  }
}

.filtrate {
  width: 1060px;
  // margin-left: 420px;
  // background: orange;

  .filtrate_head {
    height: 130px;
    width: 100%;
    margin-bottom: 30px;
    // background: pink;
    .filtrate_filer {
      height: 46px;
      width: 1040px;
      background: rgba(238, 238, 238, 1);
      border: 1px solid rgba(221, 221, 221, 1);
      font-size: 16px;
      font-family: "MicrosoftYaHei";
      font-weight: 400;
      color: rgba(51, 51, 51, 1);
      line-height: 46px;
      padding-left: 14px;
    }

    .el-input__inner {
      // height: 28px;
    }
    .el-input__icon {
      line-height: 28px;
    }
  }
  .form-title {
    height: 46px;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  .filtrate_center {
    border-left: 1px solid rgba(221, 221, 221, 1);
    border-top: 1px solid rgba(221, 221, 221, 1);
    border-right: 1px solid rgba(221, 221, 221, 1);
  }
  .center_list_head {
    width: 100%;
    height: 46px;
    // background: orange;
    display: flex;
    justify-content: space-between;
    .center_list_head_left {
      display: flex;
      align-items: center;
      > div {
        margin-left: 10px;
      }
    }

    .center_list_head_rig {
      width: 100px;
      height: 30px;
      background: rgba(255, 255, 255, 1);
      border: 1px solid rgba(221, 221, 221, 1);
      font-size: 12px;
      font-family: "MicrosoftYaHeiLight";
      font-weight: 300;
      color: rgba(153, 153, 153, 1);
      margin: 7px 30px 0 0;
      line-height: 30px;
      text-align: center;
      cursor: pointer;
    }
    .center_list_head_rig:hover {
      color: #0099ff;
    }
  }
}

.brand-page {
  background: #f5f5f5;
  color: #333;

  .claify {
    width: 4px;
    height: 16px;
    background: rgba(52, 152, 219, 1);
    position: absolute;
    top: 17px;
    left: -10px;
  }

  .cover {
    width: 50px;
    display: block;
    margin: 0 auto;
  }
  .topBar {
    margin-bottom: 40px;
  }
  .subTitle {
    position: relative;
    width: 1056px;
    margin: 0 auto;
    font-size: 14px;
  }
  .num {
    width: 40px;
    height: 38px;
    background: rgba(238, 238, 238, 1);
    border: 1px solid rgba(221, 221, 221, 1);
    text-align: center;
    line-height: 38px;
    position: absolute;
    top: 10px;
    right: 50%;
  }
}
</style>

